
















import { Vue, Component, Prop, Watch, Ref } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { ILoginThreshList } from '@/store/home/stats/types';
import * as echarts from 'echarts';
import { orgOption, userOption } from './options';

const Stats = namespace('home/stats');

@Component
export default class LoginExceptionChart extends Vue {
  @Stats.State('loginThreshList') public list!: ILoginThreshList;

  @Prop() public cols!: number; // 布局列宽
  @Prop() public title!: string;

  @Ref('chart1') public chart1Dom!: HTMLDivElement;
  @Ref('chart2') public chart2Dom!: HTMLDivElement;

  public chart1!: echarts.ECharts;  // 组织统计图表
  public chart2!: echarts.ECharts;  // 用户统计图表

  public mounted() {
    this.chart1 = echarts.init(this.chart1Dom);
    this.chart2 = echarts.init(this.chart2Dom);
    this.chart1.setOption(orgOption);  // 初始化配置(没有数据)
    this.chart2.setOption(userOption); // 初始化配置(没有数据)
    window.addEventListener('resize', this.watchCols.bind(this));
  }

  public beforeDestroy() {
    window.removeEventListener('resize', this.watchCols);
  }

  // 列宽变更时，调整图表大小
  @Watch('cols')
  public watchCols() {
    this.$nextTick(() => {
      this.chart1.resize();
      this.chart2.resize();
    });
  }

  // 初始化图表数据
  @Watch('list.data', { immediate: true })
  public dataChange(data: ILoginThreshList['data']) {
    // 组织统计
    const list1 = data.filter((item) => item.type === 1);
    const xAxisTimeData = list1.map((item) => item.orgName);
    const totalList1 = list1.map((item) => ({ ...item, value: item.totalCount }));
    const hasData1 = !!list1.length;

    // 用户统计
    const list2 = data.filter((item) => item.type === 2);
    const xAxisCountData = list2.map((item) => item.userName);
    const totalList12 = list2.map((item) => ({ ...item, value: item.totalCount }));
    const hasData2 = !!list2.length;

    this.$nextTick(() => {
      this.chart1.setOption({
        tooltip: { formatter: this.tipFormat1 },
        xAxis: [{ data: xAxisTimeData }],
        series: [{ data: totalList1 }],
        graphic: { invisible: hasData1 },
        nameTextStyle: { color: hasData1 ? '' : 'transparent' },
      });
      this.chart2.setOption({
        tooltip: { formatter: this.tipFormat2 },
        xAxis: [{ data: xAxisCountData }],
        series: [{ data: totalList12 }],
        graphic: { invisible: hasData2 },
        nameTextStyle: { color: hasData2 ? '' : 'transparent' },
      });
    });
  }

  // tooltip 内容格式化(组织)
  public tipFormat1(params: any) {
    const record = params[0]!.data;
    const totalCount = record.totalCount || 0;
    return `
      <div>组织名称：${record.orgName}</div>
      <div>异常登录人数：${totalCount}人</div>
    `;
  }

  // tooltip 内容格式化(用户)
  public tipFormat2(params: any) {
    const record = params[0]!.data;
    const totalCount = record.totalCount || 0;
    return `
      <div>用户名称：${record.userName}</div>
      <div>所属组织：${record.orgName}</div>
      <div>登录次数：${totalCount}次</div>
    `;
  }
}
